export const SET_VIRTUAL_MIRROR_SCRIPTS_LOADED_STATUS = 'SET_VIRTUAL_MIRROR_SCRIPTS_LOADED_STATUS'
export const SET_VIRTUAL_MIRROR_VISIBILITY = 'SET_VIRTUAL_MIRROR_VISIBILITY'
export const mutations = {
  [SET_VIRTUAL_MIRROR_SCRIPTS_LOADED_STATUS]: function (state, payload) {
    state.areScriptsLoaded = payload
  },
  [SET_VIRTUAL_MIRROR_VISIBILITY]: function (state, payload) {
    state.isVisible = payload
  },
}
